import { useIsRestoring, useQuery } from "@tanstack/react-query";
import { SeasonsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";

/**
 * Public hook to get a single season by ID (no authentication required)
 */
export const useSeasonGetPublic = (id: number | null | undefined) => {
  const isRestoring = useIsRestoring();
  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.Seasons, id, "public"],
    queryFn: () => {
      if (!id) {
        throw new Error("Season ID is required");
      }
      // Create API instance without authentication for public access
      const service = new SeasonsApi(createOpenApiConfiguration());
      return service.getSeasonById({ id });
    },
    enabled: !!id && !isRestoring,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};
